type RelativeScroll = {
	top: number,
	bottom: number,
	left: number,
	right: number
}

export default ( elem: HTMLElement ): RelativeScroll => {
	const topScroll = elem.scrollTop;
	const bottomScroll = elem.scrollHeight - elem.clientHeight - topScroll;

	const leftScroll = elem.scrollLeft;
	const rightScroll = elem.scrollWidth - elem.clientWidth - leftScroll;

	return {
		top: topScroll,
		bottom: bottomScroll,
		left: leftScroll,
		right: rightScroll,
	};


};
